
const digest = '26aaf2d1dbe9dc5e302ee8400619598f284460192c9a938431a20e9d6eb52925';
const classes = {"wrapper":"_wrapper_1bt0a_1"};
const css = `._wrapper_1bt0a_1 {
  background: #fbfbfd;
  font-family: Rubik, "sans-serif";
}
._wrapper_1bt0a_1 tr th {
  color: #3e3f42;
  font-size: 12px;
  font-weight: 400;
  padding: 14px 8px;
}
._wrapper_1bt0a_1 tr th:first-of-type {
  padding-left: 14px;
}
._wrapper_1bt0a_1 tr th:last-of-type {
  padding-right: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  